import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=2afdd564&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=2afdd564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdd564",
  null
  
)

export default component.exports